import api from '../utils/api';

const studentInterventionService = {
  summary: () => api.get('/api/student-support/intervention-summary'),
  plans: caseId => api.get('/api/student-support/intervention-plans', { params: caseId ? { case_id: caseId } : {} }),
  createPlan: data => api.post('/api/student-support/intervention-plans', data),
  progress: planId => api.get(`/api/student-support/intervention-plans/${planId}/progress`),
  addProgress: (planId, data) => api.post(`/api/student-support/intervention-plans/${planId}/progress`, data),
};

export default studentInterventionService;